import apiHandler from "../core/apiHandler";

const dteConfigurationApi = apiHandler('dte-configuration');
export default dteConfigurationApi;
